// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HelpPage_uC5eo{
  background:linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
}
.HelpPageContent_kGB6X {
  min-height: 100vh;
  width: 90%;
  margin: 70px auto;
  h2 {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .searchArticleContainer_LvY2A {
    width: 50%;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (width<=768px) {
      width: 100%;
    }
    h3 {
      margin: 0;
      color: #1F1F1F;
    }
    p{
        color: #676767;

    }
    .inputContainer_umZrb {
      width: 70%;
      position: relative;
    }
  }

  .articlesContainer_hguZw {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 30px;
  }

  .articleCard_lrPNb {
    background: var(--f5-background);
    padding: 20px;
    cursor: pointer;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    h4{
        font-weight: 500;
    }
    p{
        color: #737373;
    }
    &:hover{
      background-color: var(--ececf1-background);
    }
}



  .articleIcon_mFQcM {
    font-size: 40px;
    margin-bottom: 10px;
  }

  @media (min-width: 1024px) {
    .articlesContainer_hguZw {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (max-width: 768px) {
    .articlesContainer_hguZw {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 480px) {
    .articlesContainer_hguZw {
      grid-template-columns: repeat(1, 1fr);
    }
  }

}
.searchContainerIcon_vxM_i {
  background-color: var(--ececf1-background);
  padding: 4px;
  border-radius: 4px;
  height: 10px;
  width: 10px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  cursor: pointer;
}
.recomendQuestions_Sfh35{
  cursor: pointer;
  position: absolute;
  background-color: var(--white-color);
  display: flex;
  flex-direction: column;
  border: 1px solid #D9D9E3;
  top: calc(100% + 5px);
  width: 100%;
  max-height: 50vh;
  overflow-y: scroll;
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  -ms-border-radius: 12px;
  -o-border-radius: 12px;
  scrollbar-width: none;

  >div
{
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .articleItem_oMzqW{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #D9D9E3;
    padding: 10px;
    box-sizing: border-box;
    svg{
      fill: var(--_2-color);
    }
    >div{
      text-align: start;
      display: flex;
      flex-direction: column;
    }
    p{
      margin: 0;
      width: fit-content;

    }
  }
}.recomendQuestions_Sfh35::-webkit-scrollbar {
  display: none; 
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/HelpPage/HelpPage.module.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;AAC9D;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB;MACE,WAAW;IACb;IACA;MACE,SAAS;MACT,cAAc;IAChB;IACA;QACI,cAAc;;IAElB;IACA;MACE,UAAU;MACV,kBAAkB;IACpB;EACF;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;MACE,0CAA0C;IAC5C;AACJ;;;;EAIE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;AAEF;AACA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB;;IAEE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB;MACE,qBAAqB;IACvB;IACA;MACE,iBAAiB;MACjB,aAAa;MACb,sBAAsB;IACxB;IACA;MACE,SAAS;MACT,kBAAkB;;IAEpB;EACF;AACF,CAAC;EACC,aAAa;AACf","sourcesContent":[".HelpPage{\n  background:linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);\n}\n.HelpPageContent {\n  min-height: 100vh;\n  width: 90%;\n  margin: 70px auto;\n  h2 {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .searchArticleContainer {\n    width: 50%;\n    margin: 0 auto;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    @media (width<=768px) {\n      width: 100%;\n    }\n    h3 {\n      margin: 0;\n      color: #1F1F1F;\n    }\n    p{\n        color: #676767;\n\n    }\n    .inputContainer {\n      width: 70%;\n      position: relative;\n    }\n  }\n\n  .articlesContainer {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    margin-top: 30px;\n  }\n\n  .articleCard {\n    background: var(--f5-background);\n    padding: 20px;\n    cursor: pointer;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    h4{\n        font-weight: 500;\n    }\n    p{\n        color: #737373;\n    }\n    &:hover{\n      background-color: var(--ececf1-background);\n    }\n}\n\n\n\n  .articleIcon {\n    font-size: 40px;\n    margin-bottom: 10px;\n  }\n\n  @media (min-width: 1024px) {\n    .articlesContainer {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n\n  @media (max-width: 768px) {\n    .articlesContainer {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  @media (max-width: 480px) {\n    .articlesContainer {\n      grid-template-columns: repeat(1, 1fr);\n    }\n  }\n\n}\n.searchContainerIcon {\n  background-color: var(--ececf1-background);\n  padding: 4px;\n  border-radius: 4px;\n  height: 10px;\n  width: 10px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  cursor: pointer;\n}\n.recomendQuestions{\n  cursor: pointer;\n  position: absolute;\n  background-color: var(--white-color);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #D9D9E3;\n  top: calc(100% + 5px);\n  width: 100%;\n  max-height: 50vh;\n  overflow-y: scroll;\n  border-radius: 12px;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  -ms-border-radius: 12px;\n  -o-border-radius: 12px;\n  scrollbar-width: none;\n\n  >div\n{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .articleItem{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    border-bottom: 1px solid #D9D9E3;\n    padding: 10px;\n    box-sizing: border-box;\n    svg{\n      fill: var(--_2-color);\n    }\n    >div{\n      text-align: start;\n      display: flex;\n      flex-direction: column;\n    }\n    p{\n      margin: 0;\n      width: fit-content;\n\n    }\n  }\n}.recomendQuestions::-webkit-scrollbar {\n  display: none; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"HelpPage": `HelpPage_uC5eo`,
	"HelpPageContent": `HelpPageContent_kGB6X`,
	"searchArticleContainer": `searchArticleContainer_LvY2A`,
	"inputContainer": `inputContainer_umZrb`,
	"articlesContainer": `articlesContainer_hguZw`,
	"articleCard": `articleCard_lrPNb`,
	"articleIcon": `articleIcon_mFQcM`,
	"searchContainerIcon": `searchContainerIcon_vxM_i`,
	"recomendQuestions": `recomendQuestions_Sfh35`,
	"articleItem": `articleItem_oMzqW`
};
export default ___CSS_LOADER_EXPORT___;
